import { createEntityAdapter } from '@reduxjs/toolkit';

const leadsAdapter = createEntityAdapter();

export default leadsAdapter;
